import { Action } from 'redux';
import { ApplicationQualificationStateStructure } from '../../angular-elements/shared/interfaces/applicationQualificationStateStructure.interface';

export const APPLICATION_QUALIFICATION_STATE_NAME = 'applicationQualification';

export class PayloadAction implements Action {
  type: string;
  applicationQualification?: ApplicationQualificationStateStructure;
}

const INITIAL_STATE: ApplicationQualificationStateStructure = {
  baseMessage: { returnCode: 999, returnCodeDescription: "Service Not Run" },
  payload: { qualified: "false", application: "GI" }
};

export const STORE_APPLICATION_QUALIFICATION = 'STORE_APPLICATION_QUALIFICATION';
export const INIT_PAYLOAD = 'INIT_PAYLOAD';
const RESET_STATE = 'RESET_STATE_APPLICATION_QUALIFICATION';

export function setApplicationQualificationService(response: ApplicationQualificationStateStructure): PayloadAction {
  return {
    type: STORE_APPLICATION_QUALIFICATION,
    applicationQualification: response
  };
}

export function resetApplicationQualification(): PayloadAction {
  return { type: RESET_STATE };
}

export function applicationQualification(state: ApplicationQualificationStateStructure = INITIAL_STATE, action: PayloadAction) {
  let copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case STORE_APPLICATION_QUALIFICATION:
      copiedState = action.applicationQualification;
      return Object.assign({}, state, copiedState);
    case RESET_STATE:
      return INITIAL_STATE;
    case INIT_PAYLOAD:
    default:
      return state;
  }
}

